<template>
	<div
		v-if="resource"
		role="toolbar"
		class="flex flex-row flex-wrap gap-1 p-1 bg-white rounded"
	>
		<AppButton
			v-if="showCreateButton && 'create' in resource.actions"
			v-tooltip="{
        content: 'U heeft geen rechten om deze actie uit te voeren.',
        disabled: $isAllowed(`create ${camelCaseResource}`),
        placement: 'bottom'
      }"
			icon="fa-plus"
			:disabled="
        disableCreateButton ||
          $isAllowed(`create ${camelCaseResource}`) == false
      "
			@click="emit('create')"
		>
			{{ $t('actions.create {0}', [$t(`entities.${resourceKey}`)]) }}
		</AppButton>
		<slot/>
		<AppButton
			v-if="showDeleteButton && 'delete' in resource.actions"
			v-tooltip="{
        content: 'U heeft geen rechten om deze actie uit te voeren.',
        disabled: $isAllowed(`delete ${camelCaseResource}`),
        placement: 'bottom'
      }"
			icon="fa-trash"
			color="danger"
			class="ml-auto"
			:disabled="
        disableDeleteButton ||
          !$isAllowed(`delete ${camelCaseResource}`) &&
          !$isAllowed(`deleteBulk ${camelCaseResource}`)
      "
			@click="emit('delete')"
		>
			{{ $t("common.verbs.delete") }}
		</AppButton>
	</div>
</template>

<script setup lang="ts">
import { useApiResources } from "~/stores/ApiResources";

type DataGridToolbarProps = {
	resourceKey: string;
	resourceName: string;
	showCreateButton?: boolean;
	showDeleteButton?: boolean;
	disableCreateButton?: boolean;
	disableDeleteButton?: boolean;
};

const { findByName } = useApiResources();
const props = withDefaults(defineProps<DataGridToolbarProps>(), {
	showCreateButton: true,
	showDeleteButton: true,
	disableCreateButton: false,
	disableDeleteButton: false,
});

const camelCaseResource = props.resourceKey
	.split("-")
	.map((word, index) => {
		if (index == 0) {
			return word;
		}

		return word[0].toUpperCase() + word.slice(1);
	})
	.join("");
const resource = computed(() => findByName(props.resourceKey));

const emit = defineEmits(["create", "delete"]);
</script>
